// src/pages/groups/AddGroupForm.js
import React, { useState } from 'react';
import axios from 'axios';


const AddGroupForm = ({ onClose, onGroupAdded }) => {
  const [groupName, setGroupName] = useState('');
  const API_URL = process.env.REACT_APP_API_URL;
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await axios.post(`${API_URL}/ems/groups`, { group_name: groupName }); // ✅ Uses token & baseURL automatically
      onGroupAdded();  // Refresh group list
      onClose();       // Close modal
    } catch (err) {
      console.error('Error creating group:', err.response?.data || err.message);
      alert('Failed to create group');
    }
  };

  return (
    <div className="modal show d-block" tabIndex="-1" role="dialog" style={{ backgroundColor: 'rgba(0,0,0,0.4)' }}>
      <div className="modal-dialog modal-md" role="document">
        <div className="modal-content">
          <form onSubmit={handleSubmit}>
            <div className="modal-header">
              <h5 className="modal-title">Add Group</h5>
              <button type="button" className="btn-close" onClick={onClose}></button>
            </div>

            <div className="modal-body">
              <div className="mb-3">
                <label className="form-label">Group Name</label>
                <input
                  type="text"
                  className="form-control"
                  value={groupName}
                  onChange={(e) => setGroupName(e.target.value)}
                  required
                />
              </div>
            </div>

            <div className="modal-footer">
              <button type="submit" className="btn btn-warning">Add</button>
              <button type="button" className="btn btn-secondary" onClick={onClose}>Cancel</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddGroupForm;
